import { EditorialPage } from './EditorialPage';

export default EditorialPage;
